module.exports = __webpack_public_path__ + "img/newYouth.762ddd1d.png";